import { ReactNode, useRef, useState } from 'react'
import { createPortal } from 'react-dom'

// A lightweight hover tooltip that renders its bubble in a portal on document.body
// with fixed positioning. Unlike an absolutely-positioned tooltip, it is never clipped
// by an ancestor's `overflow` (e.g. a scrollable DataGrid), so it works for grid cells.
export function HoverTip({ message, children }: { message: ReactNode; children: ReactNode }) {
  const ref = useRef<HTMLSpanElement>(null)
  const [pos, setPos] = useState<{ x: number; y: number } | null>(null)

  if (message === null || message === undefined || message === false || message === '') return <>{children}</>

  const show = () => {
    const el = ref.current
    if (!el) return
    const r = el.getBoundingClientRect()
    setPos({ x: r.left + r.width / 2, y: r.top })
  }
  const hide = () => setPos(null)

  return (
    <span ref={ref} className="inline-flex" onMouseEnter={show} onMouseLeave={hide} onClick={hide}>
      {children}
      {pos &&
        createPortal(
          <div
            className="pointer-events-none fixed z-[9999] -translate-x-1/2 -translate-y-full whitespace-nowrap rounded-md bg-gray-900 px-2 py-1 text-xs font-medium text-white shadow-lg"
            style={{ left: pos.x, top: pos.y - 6 }}
          >
            {message}
          </div>,
          document.body,
        )}
    </span>
  )
}
